(() => {
  const arrays = ['lines', 'methods', 'moments', 'traits'];
  const scalars = ['goal', 'format', 'time', 'sort'];
  const money = value => (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  function init(root) {
    if (root.dataset.objectivesReady || !window.HolyObjectiveRules) return;
    root.dataset.objectivesReady = 'true';
    const rules = window.HolyObjectiveRules;
    const integrated = root.hasAttribute('data-ho-integrated');
    const original = root.querySelector('[data-ho-original]');
    const goals = JSON.parse(root.querySelector('[data-ho-goals]').textContent);
    const form = root.querySelector('[data-ho-filters]');
    const overlay = root.querySelector('[data-ho-overlay]');
    const panel = overlay.querySelector('[role=dialog]');
    const openButton = root.querySelector('[data-ho-open]');
    const closeButton = root.querySelector('[data-ho-close]');
    const sorted = root.querySelector('[data-ho-sorted]');
    const shelves = [...root.querySelectorAll('[data-ho-group]')];
    const products = [...root.querySelectorAll('[data-ho-card]')].map(card => {
      const data = JSON.parse(card.querySelector('[data-ho-data]').textContent);
      // Offers already contain only eligible sale items, including public kits from other collections.
      if (root.classList.contains('hc-collection--offers')) data.inScope = true;
      const anchor = document.createComment('product-position'); card.before(anchor);
      return { ...rules.resolveProduct(data), card, anchor, group: card.dataset.group };
    });
    const total = rules.select(products, {}).length;
    const baseTitle = root.querySelector('[data-ho-title]').textContent;
    const baseIntro = root.querySelector('[data-ho-intro]').textContent;
    const menu = document.getElementById('hs-objective-menu');
    let applied = {}, inertElements = [], priorOverflow = '', priorFocus;
    const controls = () => [...form.elements].filter(el => el.name);
    function read() {
      const data = new FormData(form), state = {};
      for (const key of arrays) state[key] = data.getAll(key);
      for (const key of scalars) state[key] = data.get(key) || '';
      state.offers = data.has('offers'); state.stock = data.has('stock');
      if (data.get('max') !== null && data.get('max') !== '') state.max = Math.max(0, Math.round(Number(data.get('max')) * 100));
      if (form.elements.maxPortion && Number(form.elements.maxPortion.value) < Number(form.elements.maxPortion.max)) state.maxPortion = Math.round(Number(form.elements.maxPortion.value) * 100);
      return state;
    }
    function fill(state) {
      controls().forEach(el => {
        el.disabled = false;
        if (el.type === 'checkbox') el.checked = arrays.includes(el.name) ? (state[el.name] || []).includes(el.value) : !!state[el.name];
        else if (el.type === 'radio') el.checked = String(state[el.name] || '') === el.value;
        else if (el.name === 'maxPortion') el.value = state.maxPortion == null ? el.max : state.maxPortion / 100;
        else if (el.name === 'max') el.value = state.max == null ? '' : state.max / 100;
        else el.value = state[el.name] || '';
      });
    }
    function load() {
      const query = new URL(location.href).searchParams, state = {};
      for (const key of arrays) state[key] = query.getAll('ho_' + key);
      for (const key of scalars) state[key] = query.get('ho_' + key) || '';
      for (const key of ['offers', 'stock']) state[key] = query.get('ho_' + key) === '1';
      for (const key of ['max', 'maxPortion']) if (query.has('ho_' + key) && query.get('ho_' + key) !== '') { const n = Number(query.get('ho_' + key)); if (Number.isFinite(n)) state[key] = Math.max(0, Math.round(n * 100)); }
      const legacy = { tempo: 'praticidade', organizar: 'praticidade', variar: 'praticidade', porcoes: 'emagrecimento' };
      state.goal = goals[state.goal] ? state.goal : legacy[state.goal] || '';
      fill(state); applied = read();
    }
    function save() {
      const url = new URL(location.href);
      for (const key of [...url.searchParams.keys()]) if (key.startsWith('ho_')) url.searchParams.delete(key);
      for (const key of arrays) for (const v of applied[key] || []) url.searchParams.append('ho_' + key, v);
      for (const key of scalars) if (applied[key]) url.searchParams.set('ho_' + key, applied[key]);
      for (const key of ['offers', 'stock']) if (applied[key]) url.searchParams.set('ho_' + key, '1');
      for (const key of ['max', 'maxPortion']) if (applied[key] != null) url.searchParams.set('ho_' + key, applied[key] / 100);
      history.pushState(null, '', url);
    }
    function arrows(shelf) {
      const track = shelf.querySelector('[data-hc-track]');
      shelf.querySelector('[data-hc-direction="-1"]').disabled = track.scrollLeft <= 2;
      shelf.querySelector('[data-hc-direction="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function makeChips(container, state, isDraft) {
      container.replaceChildren();
      function add(key, value, label) {
        const button = document.createElement('button'); button.type = 'button';
        button.textContent = label + ' ×'; button.setAttribute('aria-label', 'Remover filtro: ' + label);
        button.addEventListener('click', () => {
          const next = { ...state };
          if (arrays.includes(key)) next[key] = (next[key] || []).filter(x => x !== value);
          else delete next[key];
          fill(next);
          if (isDraft) preview(); else { applied = read(); save(); render(); }
        });
        container.append(button);
      }
      for (const el of controls()) {
        const key = el.name;
        if (key === 'sort' || key === 'max' || key === 'maxPortion') continue;
        const selected = arrays.includes(key) ? (state[key] || []).includes(el.value) : el.type === 'checkbox' ? state[key] : String(state[key] || '') === el.value && !!el.value;
        if (!selected) continue;
        add(key, el.value, el.closest('label').querySelector('span > span')?.textContent || el.closest('label').textContent.trim());
      }
      if (state.maxPortion != null) add('maxPortion', null, 'Até ' + money(state.maxPortion) + '/porção');
      if (state.max != null) add('max', null, 'Até ' + money(state.max) + ' no total');
      container.hidden = !container.children.length;
    }
    function preview() {
      // Enable checked values before reading, even when their current count is zero.
      controls().filter(el => el.checked).forEach(el => el.disabled = false);
      const draft = read(), count = rules.select(products, draft).length;
      root.querySelector('[data-ho-draft-count]').textContent = count + ' de ' + total + ' produtos';
      const submit = root.querySelector('[data-ho-apply]'); submit.textContent = count ? 'Ver ' + count + (count === 1 ? ' produto' : ' produtos') : 'Nenhum produto'; submit.disabled = count === 0;
      controls().filter(el => ['checkbox', 'radio'].includes(el.type)).forEach(el => {
        const value = ['stock', 'offers'].includes(el.name) ? true : el.value;
        const count = rules.countOption(products, draft, el.name, value);
        const label = el.closest('label'), badge = label.querySelector('[data-ho-option-count]');
        if (badge) badge.textContent = count;
        el.disabled = !el.checked && count === 0;
        label.classList.toggle('is-empty', el.disabled);
      });
      makeChips(root.querySelector('[data-ho-draft-chips]'), draft, true);
      const priceLabel = root.querySelector('[data-ho-price-label]');
      if (priceLabel) {
        priceLabel.textContent = draft.maxPortion == null ? 'Sem limite' : 'Até ' + money(draft.maxPortion);
        form.elements.maxPortion.setAttribute('aria-valuetext', priceLabel.textContent);
        const comparable = rules.select(products, { ...draft, maxPortion: undefined }).filter(p => p.servings > 0);
        root.querySelector('[data-ho-price-hint]').textContent = comparable.length ? 'Nesta seleção, a partir de ' + money(Math.min(...comparable.map(p => Math.round(p.price / p.servings)))) + ' por porção.' : 'Sem rendimento confirmado para comparar nesta seleção.';
      }
    }
    function render() {
      const shown = rules.select(products, applied), set = new Set(shown);
      products.forEach(p => { p.card.hidden = !set.has(p); });
      const filtered = arrays.some(k => applied[k]?.length) || applied.format || applied.time || applied.offers || applied.stock || applied.max != null || applied.maxPortion != null;
      const useGrid = !!applied.sort || !!filtered || (integrated && !!applied.goal);
      sorted.hidden = !useGrid;
      if (integrated) {
        original.hidden = useGrid;
        if (useGrid) shown.forEach(p => sorted.append(p.card));
        else products.forEach(p => { p.anchor.after(p.card); p.card.hidden = false; });
      } else if (useGrid) { shown.forEach(p => sorted.append(p.card)); shelves.forEach(s => s.hidden = true); }
      else shelves.forEach(s => { const track = s.querySelector('[data-hc-track]'); products.filter(p => p.group === s.dataset.hoGroup).forEach(p => track.append(p.card)); s.hidden = !shown.some(p => p.group === s.dataset.hoGroup); track.scrollLeft = 0; arrows(s); });
      root.querySelector('[data-ho-count]').textContent = shown.length + (shown.length === 1 ? ' produto' : ' produtos');
      root.querySelector('[data-ho-empty]').hidden = !!shown.length;
      root.querySelector('[data-ho-title]').textContent = goals[applied.goal]?.[0] || root.dataset.scopeTitle || baseTitle;
      root.querySelector('[data-ho-intro]').textContent = goals[applied.goal]?.[1] || baseIntro;
      const goalBanner = root.querySelector('[data-hc-banner]');
      if (goalBanner) goalBanner.style.display = applied.goal ? 'none' : '';
      const note = root.querySelector('[data-ho-note]');
      const messages = [];
      if (applied.goal === 'emagrecimento') messages.push('Uma seleção para organizar a rotina alimentar. Não é uma promessa de perda de peso.');
      if (['vegano','vegetariano'].includes(applied.goal) || applied.traits?.some(t => ['vegano','vegetariano','semGluten'].includes(t))) messages.push('Confira os ingredientes e os avisos de alergênicos na página de cada produto.');
      if (applied.time) messages.push('Nas aveias, o tempo corresponde ao mingau no fogão ou bolo de caneca no micro-ondas, com ingredientes adicionais. Nos kits, considere uma embalagem por vez.');
      if (applied.maxPortion != null) messages.push('Preço por porção calculado pelo rendimento, antes do Pix. Não inclui acompanhamentos.');
      note.textContent = messages.join(' '); note.hidden = !messages.length;
      makeChips(root.querySelector('[data-ho-active]'), applied, false);
      if (!integrated) menu?.querySelectorAll('[data-ho-goal]').forEach(a => { const url = new URL(location.href); url.searchParams.set('ho_goal', a.dataset.hoGoal); a.href = url; if (a.dataset.hoGoal === applied.goal) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
    }
    function open() {
      fill(applied); preview(); priorFocus = document.activeElement;
      overlay.hidden = false; openButton.setAttribute('aria-expanded','true');
      priorOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
      for (let branch = overlay; branch.parentElement && branch.parentElement !== document.documentElement; branch = branch.parentElement) {
        for (const sibling of branch.parentElement.children) if (sibling !== branch && !sibling.inert) { sibling.inert = true; inertElements.push(sibling); }
      }
      closeButton.focus();
    }
    function close() {
      overlay.hidden = true; openButton.setAttribute('aria-expanded','false');
      inertElements.forEach(el => el.inert = false); inertElements = [];
      document.documentElement.style.overflow = priorOverflow;
      if (priorFocus?.isConnected) priorFocus.focus({preventScroll:true});
      fill(applied);
    }
    openButton.hidden = false; openButton.addEventListener('click', open); closeButton.addEventListener('click', close);
    overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
    overlay.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('button,input,select,a[href],[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    form.addEventListener('input', preview); form.addEventListener('change', preview);
    form.addEventListener('submit', e => { e.preventDefault(); const next = read(); if (!rules.select(products, next).length) return; applied = next; save(); render(); close(); });
    root.querySelector('[data-ho-reset]').addEventListener('click', () => { fill({}); preview(); });
    root.querySelector('[data-ho-clear]').addEventListener('click', () => { fill({}); applied = read(); save(); render(); });
    shelves.forEach(s => {
      s.querySelector('[data-hc-track]').addEventListener('scroll', () => arrows(s), { passive:true });
      s.querySelectorAll('[data-hc-direction]').forEach(b => b.addEventListener('click', e => { e.stopImmediatePropagation(); const track = s.querySelector('[data-hc-track]'), card = track.querySelector('[data-ho-card]:not([hidden])'); if(card) track.scrollBy({left:(card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap))*Number(b.dataset.hcDirection),behavior:'smooth'}); }, true));
    });
    if (menu && !integrated) {
      menu.querySelectorAll(':scope > a').forEach(a => a.remove());
      for (const [key,text] of Object.entries(goals)) {
        const a=document.createElement('a'), strong=document.createElement('strong'), span=document.createElement('span');
        a.dataset.hoGoal=key; strong.textContent=text[0]; span.textContent=text[1]; a.append(strong,span);
        const icon = controls().find(el => el.name === 'goal' && el.value === key)?.closest('label').querySelector('.hobj-goal-icon');
        if (icon) { a.prepend(icon.cloneNode(true)); a.classList.add('hobj-goal-link'); }
        a.addEventListener('click', e => { if(e.ctrlKey||e.metaKey||e.shiftKey)return; e.preventDefault(); fill({...applied,goal:key}); applied=read(); save(); render(); menu.hidden=true; document.querySelector('[data-hs-objectives]')?.setAttribute('aria-expanded','false'); root.scrollIntoView({block:'start',behavior:'auto'}); });
        menu.append(a);
      }
    }
    window.addEventListener('popstate', () => { if (!overlay.hidden) close(); load(); render(); });
    load(); render();
  }
  document.querySelectorAll('[data-holy-objectives]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-holy-objectives]').forEach(init));
})();
